import { Flex } from 'foundations-components/components/Flex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useSearchParams } from '../../hooks/useSearchParams';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { SyncDirectionFilter } from './SyncDirectionFilter';
import { LanguageFilter } from './reusableFilters/LanguageFilter';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AppFilterControls() {
  const params = useSearchParams();
  const {
    AppLanguages,
    BuiltByHubspot,
    Category,
    Certified,
    HubspotFeatures,
    PricingPlan,
    SupportLanguages,
    ToolIntegrations
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: PricingPlan
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: Category,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: HubspotFeatures,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: ToolIntegrations,
      multi: true,
      virtualized: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: BuiltByHubspot
    }), Certified && /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: "eco_certified",
        children: Certified.label
      }), /*#__PURE__*/_jsx(Toggle, {
        id: "eco_certified",
        size: "extra-small",
        checked: params.get(Certified.field) === 'true',
        onChange: e => {
          params.set(Certified.field, e.target.checked.toString(), {
            defaultValue: 'false'
          });
        }
      })]
    }), /*#__PURE__*/_jsx(SyncDirectionFilter, {}), /*#__PURE__*/_jsx(LanguageFilter, {
      filter: AppLanguages
    }), /*#__PURE__*/_jsx(LanguageFilter, {
      filter: SupportLanguages
    })]
  });
}